/* ARMATEQ collection cards: colour switching, variant-level sale display,
   sale-page colour filtering, and quick add. */
(function () {
  if (window.__aqColorwayV4) return;
  window.__aqColorwayV4 = true;

  var productCache = new Map();
  var salePage = /\/collections\/(sale|sale-1|sale-clearance|on-sale)(?:[\/?#]|$)/i.test(window.location.pathname);

  function closest(event, selector) {
    var target = event && event.target;
    return target && target.closest ? target.closest(selector) : null;
  }
  function isSale(variant) {
    return Number(variant && variant.compare_at_price) > Number(variant && variant.price);
  }
  function optionsOf(variant) {
    return Array.isArray(variant && variant.options)
      ? variant.options
      : [variant && variant.option1, variant && variant.option2, variant && variant.option3].filter(function (value) { return value != null; });
  }
  function optionIndex(product, pattern) {
    var options = product.options || [];
    for (var index = 0; index < options.length; index += 1) {
      var name = typeof options[index] === 'string' ? options[index] : options[index].name;
      if (pattern.test(String(name || ''))) return index;
    }
    return -1;
  }
  function imageUrl(source) {
    if (!source) return '';
    if (typeof source === 'string') return source;
    return source.src || source.url || source.originalSrc || '';
  }
  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
        style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol'
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }
  }
  function productEndpoint(card) {
    var link = card.querySelector('.aq-card__title a, .aq-card__link');
    if (!link) return '';
    var url = new URL(link.href, window.location.origin);
    url.search = '';
    url.hash = '';
    url.pathname = url.pathname.replace(/\.js$/, '').replace(/\/$/, '') + '.js';
    return url.pathname;
  }
  function loadProduct(card) {
    var endpoint = productEndpoint(card);
    if (!endpoint) return Promise.reject(new Error('Product URL unavailable'));
    if (productCache.has(endpoint)) return productCache.get(endpoint);
    var request = fetch(endpoint, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Product data unavailable');
      return response.json();
    }).catch(function (error) {
      productCache.delete(endpoint);
      throw error;
    });
    productCache.set(endpoint, request);
    return request;
  }
  function variantsFor(product, color, saleOnly) {
    var colorIndex = optionIndex(product, /colou?r/i);
    return (product.variants || []).filter(function (variant) {
      var matchesColor = colorIndex < 0 || color == null || String(optionsOf(variant)[colorIndex]) === String(color);
      return matchesColor && (!saleOnly || isSale(variant));
    });
  }
  function representative(variants) {
    var saleVariants = variants.filter(isSale);
    return saleVariants.find(function (variant) { return variant.available; })
      || variants.find(function (variant) { return variant.available; })
      || saleVariants[0]
      || variants[0]
      || null;
  }
  function setElementHidden(element, hidden) {
    if (!element) return;
    element.hidden = Boolean(hidden);
    element.style.display = hidden ? 'none' : '';
    element.setAttribute('aria-hidden', hidden ? 'true' : 'false');
  }
  function ensureBadge(card, className, text) {
    var badges = card.querySelector('.aq-card__badges');
    if (!badges) return null;
    var badge = badges.querySelector('.' + className);
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'aq-badge ' + className;
      badges.prepend(badge);
    }
    badge.textContent = text;
    return badge;
  }
  function updateMerchandising(card, variant, candidates) {
    if (!variant) return;
    var onSale = isSale(variant);
    var available = candidates.some(function (item) { return item.available; });
    var saleBadge = ensureBadge(card, 'aq-badge--sale', '');
    var soldOutBadge = ensureBadge(card, 'aq-badge--soldout', 'Sold out');
    var price = card.querySelector('.aq-price');
    var lowStock = card.querySelector('.aq-lowstock');

    if (onSale) {
      var saved = Math.round((Number(variant.compare_at_price) - Number(variant.price)) * 100 / Number(variant.compare_at_price));
      saleBadge.textContent = 'Save ' + saved + '%';
      setElementHidden(saleBadge, false);
      if (price) {
        price.innerHTML = '<span class="aq-price__was">' + money(variant.compare_at_price) + '</span>'
          + '<span class="aq-price__sale">' + money(variant.price) + '</span>';
      }
    } else {
      setElementHidden(saleBadge, true);
      if (price) price.innerHTML = '<span>' + money(variant.price) + '</span>';
    }
    setElementHidden(soldOutBadge, available);

    var quantity = Number(variant.inventory_quantity);
    if (lowStock && Number.isFinite(quantity) && quantity > 0 && quantity <= 10 && available) {
      lowStock.textContent = 'Only ' + quantity + ' left';
      setElementHidden(lowStock, false);
    } else if (lowStock) {
      setElementHidden(lowStock, true);
    }
  }
  function productHref(card, variantId) {
    var link = card.querySelector('.aq-card__title a, .aq-card__link');
    if (!link) return '';
    var url = new URL(link.href, window.location.origin);
    url.search = '';
    url.searchParams.set('variant', variantId);
    return url.pathname + url.search;
  }
  function updateImageAndLinks(card, variant) {
    var src = imageUrl(variant && variant.featured_image);
    var image = card.querySelector('.aq-card__img');
    if (image && src) {
      image.src = src;
      image.srcset = '';
    }
    var href = productHref(card, variant.id);
    card.querySelectorAll('.aq-card__link, .aq-card__title a').forEach(function (link) {
      if (href) link.setAttribute('href', href);
    });
  }
  function updateSizes(card, product, color, saleOnly) {
    var colorIndex = optionIndex(product, /colou?r/i);
    var sizeIndex = optionIndex(product, /^size$/i);
    var firstAvailable = '';

    card.querySelectorAll('.aq-size').forEach(function (button) {
      var size = button.getAttribute('data-size');
      var currentId = button.getAttribute('data-variant-id');
      var variant = (product.variants || []).find(function (item) {
        var options = optionsOf(item);
        var colorMatches = colorIndex < 0 || color == null || String(options[colorIndex]) === String(color);
        var sizeMatches = sizeIndex < 0 ? String(item.id) === String(currentId) : String(options[sizeIndex]) === String(size);
        return colorMatches && sizeMatches && (!saleOnly || isSale(item));
      });

      if (!variant) {
        button.style.display = 'none';
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.removeAttribute('data-variant-id');
        return;
      }

      button.style.display = '';
      button.setAttribute('data-variant-id', variant.id);
      button.classList.toggle('aq-size--soldout', !variant.available);
      button.disabled = !variant.available;
      if (variant.available) {
        button.removeAttribute('aria-disabled');
        if (!firstAvailable) firstAvailable = String(variant.id);
      } else {
        button.setAttribute('aria-disabled', 'true');
      }
    });

    var input = card.querySelector('form[data-type="add-to-cart-form"] [name="id"]');
    if (input && firstAvailable) input.value = firstAvailable;
  }
  function filterSalePills(card, product) {
    card.querySelectorAll('.aq-color-pill').forEach(function (pill) {
      var hasSale = variantsFor(product, pill.dataset.color, true).length > 0;
      pill.hidden = !hasSale;
      pill.style.display = hasSale ? '' : 'none';
      pill.setAttribute('aria-hidden', hasSale ? 'false' : 'true');
    });
  }
  function setCardVisible(card, visible) {
    var item = card.closest('.grid__item');
    if (!item) return;
    item.hidden = !visible;
    item.style.display = visible ? '' : 'none';
    item.style.visibility = '';
    item.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }
  function hydrate(card, requestedColor) {
    var activePill = requestedColor
      ? Array.from(card.querySelectorAll('.aq-color-pill')).find(function (pill) { return pill.dataset.color === requestedColor; })
      : card.querySelector('.aq-color-pill.is-active');
    var color = activePill ? activePill.dataset.color : null;
    card.dataset.selectedColor = color || '';
    var requestColor = card.dataset.selectedColor;

    return loadProduct(card).then(function (product) {
      if (card.dataset.selectedColor !== requestColor) return;
      if (salePage) filterSalePills(card, product);

      var candidates = variantsFor(product, color, salePage);
      if (salePage && !candidates.length) {
        setCardVisible(card, false);
        return;
      }
      var variant = representative(candidates);
      if (!variant) {
        if (salePage) setCardVisible(card, false);
        return;
      }

      setCardVisible(card, true);
      updateMerchandising(card, variant, candidates);
      updateImageAndLinks(card, variant);
      updateSizes(card, product, color, salePage);
    }).catch(function (error) {
      console.warn('ARMATEQ could not refresh this colour card.', error);
      setCardVisible(card, true);
    });
  }

  function hintFor(card) {
    var hint = card && card.querySelector('.aq-quickadd-hint');
    if (hint && !hint.dataset.defaultText) hint.dataset.defaultText = hint.textContent.trim();
    if (hint) hint.setAttribute('aria-live', 'polite');
    return hint;
  }
  function setHint(card, text) {
    var hint = hintFor(card);
    if (hint) hint.textContent = text;
  }
  function restoreHint(card, delay) {
    var hint = hintFor(card);
    if (!hint) return;
    window.setTimeout(function () {
      if (card.dataset.aqAdding === 'true') return;
      hint.textContent = hint.dataset.defaultText || 'Tap a size to add to bag';
    }, delay);
  }
  function setSizesBusy(card, busy) {
    card.querySelectorAll('.aq-size').forEach(function (button) {
      if (busy) button.disabled = true;
      else if (button.getAttribute('aria-disabled') !== 'true') button.disabled = false;
    });
  }

  document.addEventListener('aq:product-form-state', function (event) {
    var card = event.target && event.target.closest ? event.target.closest('.aq-card') : null;
    if (!card) return;
    var state = event.detail && event.detail.state;
    if (state === 'adding') {
      card.dataset.aqAdding = 'true';
      card.setAttribute('aria-busy', 'true');
      setSizesBusy(card, true);
      setHint(card, 'Adding to bag…');
    } else if (state === 'success') {
      setHint(card, 'Added to bag');
      restoreHint(card, 1600);
    } else if (state === 'error') {
      setHint(card, 'Couldn’t add. Please try again.');
      restoreHint(card, 2800);
    } else if (state === 'complete') {
      card.dataset.aqAdding = 'false';
      card.removeAttribute('aria-busy');
      setSizesBusy(card, false);
    }
  });

  document.addEventListener('click', function (event) {
    var sizeButton = closest(event, '.aq-size');
    if (sizeButton) {
      event.preventDefault();
      if (sizeButton.disabled || sizeButton.getAttribute('aria-disabled') === 'true') return;
      var card = sizeButton.closest('.aq-card');
      var form = card && card.querySelector('form[data-type="add-to-cart-form"]');
      var variantId = sizeButton.dataset.variantId;
      if (!card || !form || !variantId || card.dataset.aqAdding === 'true') return;
      var input = form.querySelector('[name="id"]');
      if (input) { input.disabled = false; input.value = variantId; }
      card.querySelectorAll('.aq-size').forEach(function (button) { button.classList.remove('is-selected'); });
      sizeButton.classList.add('is-selected');
      var submit = card.querySelector('.aq-add-submit');
      if (submit && form.requestSubmit) form.requestSubmit(submit);
      else if (submit) submit.click();
      return;
    }

    var pill = closest(event, '.aq-color-pill');
    if (!pill) return;
    event.preventDefault();
    var card2 = pill.closest('.aq-card');
    if (!card2 || card2.dataset.aqAdding === 'true') return;
    card2.querySelectorAll('.aq-color-pill').forEach(function (item) {
      item.classList.toggle('is-active', item === pill);
      item.setAttribute('aria-pressed', item === pill ? 'true' : 'false');
    });
    var image = card2.querySelector('.aq-card__img');
    if (image && pill.dataset.imgSrc) {
      image.src = pill.dataset.imgSrc;
      if (pill.dataset.imgSrcset) image.srcset = pill.dataset.imgSrcset;
    }
    hydrate(card2, pill.dataset.color);
  });

  function initialize(root) {
    var cards = [];
    if (root.matches && root.matches('.aq-card')) cards.push(root);
    if (root.querySelectorAll) root.querySelectorAll('.aq-card').forEach(function (card) { cards.push(card); });
    if (!cards.length) return Promise.resolve();

    return Promise.all(cards.map(function (card) {
      var active = card.querySelector('.aq-color-pill.is-active');
      if (active) active.setAttribute('aria-pressed', 'true');
      if (salePage) {
        var item = card.closest('.grid__item');
        if (item) item.style.visibility = 'hidden';
        return hydrate(card);
      }
      if (card.querySelector('.aq-badge--sale')) loadProduct(card).catch(function () {});
      return Promise.resolve();
    }));
  }

  var grid = document.getElementById('product-grid');
  if (salePage && grid) {
    grid.style.visibility = 'hidden';
    grid.setAttribute('aria-busy', 'true');
  }
  initialize(document).then(function () {
    if (salePage && grid) {
      grid.style.visibility = '';
      grid.removeAttribute('aria-busy');
    }
  });

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node && node.nodeType === 1) initialize(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
